import { fetchClients } from '@/services/clients'
import { ClientsActions } from './types'

const actions: ClientsActions = {
  async fetchClients({ commit }): Promise<void> {
    commit('setClients', await fetchClients())
  },
}

export default actions
